import Tooltip from "./../../../node_modules/bootstrap/js/dist/tooltip";

export default class Tooltips {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Tooltips();
		self.attachEvents();
	}

	static initTooltip($tooltip) {
		const self = new Tooltips();
		self.initTooltip($tooltip);
	}

	// static initTooltips() {
	// 	const self = new Tooltips();
	// 	self.initTooltips();
	// }

	// static destroyTooltips() {
	// 	const self = new Tooltips();
	// 	self.destroyTooltips();
	// }

	attachEvents() {
		const self = this;

		var windowWidth = $(window).width();

		// Bug fix only needed on desktop for hovering
		if (windowWidth > 991) {
			$(document).ajaxComplete(function () {
				if ($(".js-tooltip-trigger").length) {
					$(".tooltip").remove(); // bug fix for hovering on js-tooltip-trigger on ajax complete - need to remove all instances
					self.initTooltips(); // reinit tooltips
				}
			});
		}

		// $(document).on("mouseenter", ".js-tooltip-trigger", function () {
		// 	$(this).tooltip("show");
		// 	console.log("tooltip show");
		// });

		// $(document).on("mouseleave", ".js-tooltip-trigger", function () {
		// 	$(this).tooltip("hide");
		// 	console.log("tooltip hide");
		// });
	}

	initTooltip($tooltip) {
		const self = this;

		// console.log("Init tooltip");

		$tooltip.tooltip({
			trigger: "hover",
		});

		return self;
	}

	initTooltips() {
		const self = this;

		// console.log("Init all tooltips");

		if ($(".js-tooltip-trigger").length) {
			$(".js-tooltip-trigger").tooltip({
				trigger: "hover",
			});
		}
	}

	destroyTooltips() {
		const self = this;

		// console.log("Destroy all tooltips");

		if ($(".js-tooltip-trigger").length) {
			$(".js-tooltip-trigger").tooltip("dispose");
		}
	}
}
